import nodeApi from '../utils/nodeApiClient';

const billCompaniesApi = {
  list: (quotationId) => nodeApi.get('/bill-companies', { params: quotationId ? { quotation_id: quotationId } : {} }),
  listForQuotation: (quotationId) => nodeApi.get(`/bill-companies/by-quotation/${quotationId}`)
};

export default billCompaniesApi;
